module.exports = __webpack_public_path__ + "static/media/mm2.267e96b3.png";